export interface RoutedView<S=unknown>{frame():void;getState():S;destroy():void}
export type ViewFactory<S=unknown>=(state:S|undefined)=>RoutedView<S>;
const setMapChromeVisible=(visible:boolean):void=>{
  for(const id of ['vitals','hud']){
    const element=document.getElementById(id);
    if(element){element.hidden=!visible;element.style.display=visible?'':'none';}
  }
};
export function createViewRouter(options:{map:ViewFactory;tycoon:ViewFactory}):{navigate(path:'/'|'/tycoon'):void;frame():void;destroy():void}{
  const saved=new Map<string,unknown>();let active:RoutedView|undefined,activePath:string|undefined;
  const normalized=(): '/'|'/tycoon'=>location.pathname==='/tycoon'||location.pathname==='/tycoon/'?'/tycoon':'/';
  const activate=()=>{const path=normalized();if(path===activePath)return;if(active&&activePath){saved.set(activePath,active.getState());active.destroy();}setMapChromeVisible(path==='/');activePath=path;active=(path==='/tycoon'?options.tycoon:options.map)(saved.get(path));};
  const pop=()=>activate();window.addEventListener('popstate',pop);activate();
  return {navigate(path){if(path===normalized())return;history.pushState(null,'',path);activate();},frame(){active?.frame();},destroy(){window.removeEventListener('popstate',pop);active?.destroy();active=undefined;}};
}
